import { addDefinition } from '../classes/object-definition';
/* eslint-disable func-names */
export function JsonDiscriminatorValue(value) {
    return function (constructor) {
        addDefinition(constructor).discriminatorValue = value;
    };
}
//# sourceMappingURL=json-discriminator-value.js.map